<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <v-card class="mx-auto" max-width="600">
      <v-card-title class="headline">
        <v-row>
          <v-col cols="1">
            <v-icon v-if="type === 'info'" color="blue">{{ type }} </v-icon>
            <v-icon v-if="type === 'warning'" color="yellow"
              >{{ type }}
            </v-icon>
            <v-icon v-if="type === 'error'" color="red">{{ type }} </v-icon>
          </v-col>
          <v-col cols="8"> {{ type }} </v-col>
        </v-row>
      </v-card-title>
      <v-card-text style="white-space: pre-wrap; word-wrap: break-word">
        {{ comment }}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="confirm">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogMessageAsync',

  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    comment: null,
    type: null,
    color: null,
  }),

  methods: {
    open(type, comment) {
      this.dialog = true;
      this.comment = comment;
      this.type = type;
    },
    confirm() {
      this.dialog = false;
      this.$emit('confirm');
    },
  },
};
</script>
